import clsx from 'clsx';
import EAIcon from 'components/common/EAIcon';
import i18next from 'i18next';
import { useState } from 'react';
import { SecurityRatingControlScores, SecurityRatingPerformanceScores } from 'services/common/SecurityRatingUtils';
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';
import SecurityRatingLetterScoresMeaningModal from './SecurityRatingLetterScoresMeaningModal';
import SecurityRatingScoreDetailModal from './SecurityRatingScoreDetailModal';

const SecurityRatingScoreDetailLine = ({ score, value }) => {
  const { classes } = useStyles();
  const [iScoreDetailModalOpen, setScoreDetailModalOpen] = useState(false);


  return (
    <div className={classes.scoreDetail}>
      <div
        className={clsx(classes.scoreValue, `score-${value}`)}
      >
        <span>{value}</span>
      </div>
      <span className={classes.scoreLabel}>
        {i18next.t(`securityRating.scores.${score}`)}
      </span>
      <span className={classes.scoreInfoIcon} onClick={() => setScoreDetailModalOpen(true)}>
        <EAIcon icon="call_made" />
      </span>

      <SecurityRatingScoreDetailModal
        score={score}
        value={value}
        isOpen={iScoreDetailModalOpen}
        onClose={() => setScoreDetailModalOpen(false)}
      />
    </div>
  );
};

const SecurityRatingScoresDetail = ({ data }) => {
  const { classes } = useStyles();
  const [letterScoresMeaningModalOpen, setLetterScoresMeaningModalOpen] = useState(false);

  return (
    <div className={classes.scoresWrapper}>
      <div className={classes.scoresDetailWrapper}>
        <div className={classes.scoreDetailTitleWrapper}>
          <div className={classes.scoresDetailTitle}>{i18next.t("securityRating.controlMeasures")}</div>
        </div>
        <div className={classes.scoresDetailLinesWrapper}>
          {Object.values(SecurityRatingControlScores).map(score => (
            <SecurityRatingScoreDetailLine key={score} score={score} value={data[`${score}_score`]?.letter_value} />
          ))}
        </div>
      </div>
      <div className={classes.scoresDetailWrapper}>
        <div className={classes.scoreDetailTitleWrapper}>
          <div className={classes.scoresDetailTitle}>{i18next.t("securityRating.performanceMeasures")}</div>
          <div className={classes.moreDetailsBtn} onClick={() => setLetterScoresMeaningModalOpen(true)}>
            {i18next.t("moreDetails")}<EAIcon icon="call_made" />
          </div>
        </div>
        <div className={classes.scoresDetailLinesWrapper}>
          {Object.values(SecurityRatingPerformanceScores).map(score => (
            <SecurityRatingScoreDetailLine key={score} score={score} value={data[`${score}_score`]?.letter_value} />
          ))}
        </div>
      </div>


      <SecurityRatingLetterScoresMeaningModal
        isOpen={letterScoresMeaningModalOpen}
        onClose={() => setLetterScoresMeaningModalOpen(false)}
      />
    </div>
  );
};

export default SecurityRatingScoresDetail;
